@if (label()) {
    <form-label
        [id]="id() + '-textarea'"
        [forId]="id() + '-textarea'"
        [label]="label()"
        [required]="required()"
        [tooltipText]="tooltipText()"
        [hasError]="(control().errors && (control().dirty || control().touched)) || false">
    </form-label>
}

<textarea
    pTextarea
    [id]="id() + '-textarea'"
    [rows]="rows()"
    [formControl]="control()"
    [placeholder]="placeholder() | translate"
    [autoResize]="false"
    [pSize]="size()"
    [fluid]="true"
    [invalid]="control().invalid && (control().dirty || control().touched)"
    [class.no-resize]="noResize()"></textarea>

<div
    class="counter-and-validators-container"
    [class.invalid]="control().invalid && (control().dirty || control().touched)">
    @if (control().invalid && (control().dirty || control().touched)) {
        @for (error of getErrorKeys(control().errors); track error) {
            <form-error [text]="getErrorMessage(error)"></form-error>
        }
    }
    <char-counter [maxLength]="maxLength()" [text]="textValue() || ''"></char-counter>
</div>
